import React, { useState } from "react";
import { uploadLicense } from "./licenseService";
import { Server } from "lucide-react";
import { useHistory } from "react-router-dom";

export function NewLicenseUploadSection() {

    const [newLicenseKey, setNewLicenseKey] = useState('');
    const history = useHistory();

    const onSubmitClick = () => {
        return uploadLicense(newLicenseKey).then(() => history.push('/'));
    }

    return (
        <div className="oct_license-key-section-v2">
            <label>
                <Server className="oct_icon" />
                License Key
            </label>
            <div className="oct_key-input-row">
                <textarea
                    className='oct_key-textarea'
                    rows={3}
                    placeholder="Enter new license key here"
                    value={newLicenseKey}
                    onChange={(event) => setNewLicenseKey(event.target.value)}
                />
                <button
                    className="oct_settings-btn-v2 oct_license-submit-btn-v2"
                    onClick={onSubmitClick}
                >
                    Submit
                </button>
            </div>
        </div>
    )

}